import { Globe } from 'lucide-react';

import { Button } from '@/_shared/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/_shared/components/ui/dialog';

interface Props {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  pending?: boolean;
}

/** Confirmation dialog before flipping a dashboard public. The copy is
 * deliberately blunt — dashboards re-run their queries on every load, so a
 * panel that "looked safe" against today's data may surface PII tomorrow.
 * Default focus stays on Keep private to make the safe path the easy one. */
export function PublishConfirmDialog({ open, onConfirm, onCancel, pending = false }: Props): React.ReactElement {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onCancel()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Globe className="size-5" /> Publish dashboard to the web
          </DialogTitle>
          <DialogDescription className="space-y-3 text-sm">
            <span className="block">
              Anyone with the link can view this dashboard without signing in, and it may even show up in search engine
              results.
            </span>
            <span className="block">
              Dashboards re-run queries on every load. Make sure it doesn&apos;t expose PII, revenue, or sensitive
              customer data.
            </span>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} autoFocus>
            Keep private
          </Button>
          <Button onClick={onConfirm} disabled={pending}>
            Publish to the web
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
